import React from "react";

import Tooltip from "../../../../../../components/feedback/tooltip";

const TaskToolTip = ({ title, className, children }) => {
  // eslint-disable-next-line no-unused-vars
  return title ? (
    <Tooltip title={title} bigSize>
      {children}
    </Tooltip>
  ) : (
    children
  );
};

export default TaskToolTip;
